import { TextField } from "@mui/material";
import { FieldErrors } from "react-hook-form";
import { LegalPersonInput } from "../../validation";

interface ResponsibleNameInputProps {
  register: any;
  errors: FieldErrors<LegalPersonInput>;
}

const ResponsibleNameInput: React.FC<ResponsibleNameInputProps> = ({
  register,
  errors,
}) => {
  return (
    <TextField
      fullWidth
      {...register("responsibleName")}
      label="Nome do Responsável"
      required
      error={!!errors.responsibleName}
      helperText={errors.responsibleName?.message}
      variant="standard"
      inputProps={{
        style: {
          fontSize: 16,
          height: 30,
        },
      }}
    />
  );
};

export default ResponsibleNameInput;
